import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
export class AuditWasm extends Synchronized {
    mod;
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    get flushIntervalMs() {
        return this.mod.AUDIT_FLUSH_INTERVAL_MS;
    }
    isAuditEnabled() {
        return this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.IsAuditEnabled());
        });
    }
    setAuditEnabled(enabled) {
        return this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.SetAuditEnabled(enabled));
        });
    }
    advanceAuditTimers() {
        return this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.AdvanceAuditTimers());
        });
    }
    drainAuditRecords() {
        return this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.DrainAuditRecords());
        });
    }
    getOrCreateAuditLogFile() {
        return this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.GetOrCreateAuditLogFile());
        });
    }
}
